import axiosInstance from "./axiosInstance";

export async function getDashboardKpis(params = {}, options = {}) {
  const { data } = await axiosInstance.get("/api/dashboard/kpis", {
    params,
    ...options,
  });
  return data?.data ?? data;
}

export async function getDepartments(params = {}, options = {}) {
  const { data } = await axiosInstance.get("/api/dashboard/user-departments", {
    params,
    ...options,
  });
  return data?.data ?? data;
}

// ── Department Summary (HOD) ─────────────────────────────────────────────────
// GET /api/dashboard/departments
export async function getDeptSummary(params = {}, options = {}) {
  const { data } = await axiosInstance.get("/api/dashboard/departments", {
    params,
    ...options,
  });
  return data?.data ?? data;
}

// GET /api/dashboard/departments/{departmentId}/sub-departments
export async function getSubDeptSummary(departmentId, params = {}, options = {}) {
  const { data } = await axiosInstance.get(`/api/dashboard/departments/${departmentId}/sub-departments`, {
    params,
    ...options,
  });
  return data?.data ?? data;
}

// GET /api/dashboard/sub-departments/{subDepartmentId}/members
export async function getSubDeptMembers(subDepartmentId, params = {}, options = {}) {
  const { data } = await axiosInstance.get(`/api/dashboard/sub-departments/${subDepartmentId}/members`, {
    params,
    ...options,
  });
  return data?.data ?? data;
}

export async function getCompletionTrend(params = {}, options = {}) {
  const { data } = await axiosInstance.get("/api/dashboard/charts/completion-trend", {
    params,
    ...options,
  });
  return data?.data ?? data;
}

export async function getOverdueTrend(params = {}, options = {}) {
  const { data } = await axiosInstance.get("/api/dashboard/charts/overdue-trend", {
    params,
    ...options,
  });
  return data?.data ?? data;
}

export async function getTeamSummary(params = {}, options = {}) {
  const { data } = await axiosInstance.get("/api/dashboard/team", {
    params,
    ...options,
  });
  return data?.data ?? data;
}

// Returns { items, pagination } — used by IC My Tasks table
export async function getDashboardTasks(params = {}, options = {}) {
  const { data } = await axiosInstance.get("/api/dashboard/tasks", {
    params,
    ...options,
  });
  return data?.data ?? data;
}

export async function getTatSummary(params = {}, options = {}) {
  const { data } = await axiosInstance.get("/api/dashboard/tat", {
    params,
    ...options,
  });
  return data?.data ?? data;
}

export async function getAttentionItems(params = {}, options = {}) {
  const { data } = await axiosInstance.get("/api/dashboard/attention", {
    params,
    ...options,
  });
  return data?.data ?? data;
}

// Overdue tasks for the TAT panel — sorted by ageing
export async function getOverdueTasks(params = {}, options = {}) {
  const { data } = await axiosInstance.get("/api/task/list", {
    params: {
      type: "my-team",
      sortBy: "ageing",
      sortOrder: "DESC",
      ...params,
    },
    ...options,
  });
  return data?.data ?? data;
}
